import { Action } from "@ngrx/store";
import { 
    BookingService, 
    BookingServiceRequest, 
    CreateAppointmentRequest, 
    CustomQuestion, 
    SchedulingPolicy, 
    SchedulingPolicyRequest, 
    Staff, 
    StaffAvailability, 
    StaffAvailabilityRequest, 
    StaffLoadRequest 
} from "@model";

export enum BookingActionTypes{
    BookingServicesLoad = '[Booking] Services Load',
    BookingServicesLoadSuccess = '[Booking] Services Load Success',
    BookingServicesLoadFail = '[Booking] Services Load Fail',
    SelectService = '[Booking] Select Service',
    SchedulingPolicyLoad = '[Booking] Scheduling Policy Load',
    SchedulingPolicyLoadSuccess = '[Booking] Scheduling Policy Load Success',
    SchedulingPolicyLoadFail = '[Booking] Scheduling Policy Load Fail', 
    StaffAvailabilityLoad = '[Booking] Staff Availability Load',
    StaffAvailabilityLoadSuccess = '[Booking] Staff Availability Load Success',
    StaffAvailabilityLoadFail = '[Booking] Staff Availability Load Fail',
    StaffsLoad = '[Booking] Staff Load',
    StaffsLoadSuccess = '[Booking] Staff Load Success',
    StaffsLoadFail = '[Booking] Staff Load Fail',
    CreateAppointment = '[Booking] Create Appointment',
    CreateAppointmentSuccess = '[Booking] Create Appointment Success',
    CreateAppointmentFail = '[Booking] Create Appointment Fail',
    ClearAppointment = '[Booking] Clear Appointment',
    ServiceCustomQuestionsLoad = '[Booking] Service Custom Questions Load',
    ServiceCustomQuestionsLoadSuccess = '[Booking] Service Custom Questions Load Success',
    ServiceCustomQuestionsLoadFail = '[Booking] Service Custom Questions Load Fail',
}

export class BookingServicesLoad implements Action {
    readonly type = BookingActionTypes.BookingServicesLoad;
    constructor() {}
}

export class BookingServicesLoadSuccess implements Action {
    readonly type = BookingActionTypes.BookingServicesLoadSuccess;
    constructor(public payload: BookingService[]) {}
}

export class BookingServicesLoadFail implements Action {
    readonly type = BookingActionTypes.BookingServicesLoadFail;
    constructor(public payload: any) {}
}

export class SelectService implements Action {
    readonly type = BookingActionTypes.SelectService;
    constructor(public payload: BookingService) {}
}

export class SchedulingPolicyLoad implements Action {
    readonly type = BookingActionTypes.SchedulingPolicyLoad;
    constructor(public payload: SchedulingPolicyRequest) {}
}

export class SchedulingPolicyLoadSuccess implements Action {
    readonly type = BookingActionTypes.SchedulingPolicyLoadSuccess;
    constructor(public payload: SchedulingPolicy) {}
}

export class SchedulingPolicyLoadFail implements Action {
    readonly type = BookingActionTypes.SchedulingPolicyLoadFail;
    constructor(public payload: any) {}
}

export class StaffsLoad implements Action {
    readonly type = BookingActionTypes.StaffsLoad;
    constructor(public payload: StaffLoadRequest) {}
}

export class StaffsLoadSuccess implements Action {
    readonly type = BookingActionTypes.StaffsLoadSuccess;
    constructor(public payload: Staff[]) {}
}

export class StaffsLoadFail implements Action {
    readonly type = BookingActionTypes.StaffsLoadFail;
    constructor(public payload: any) {}
}

export class StaffAvailabilityLoad implements Action {
    readonly type = BookingActionTypes.StaffAvailabilityLoad;
    constructor(public payload: StaffAvailabilityRequest) {}
}

export class StaffAvailabilityLoadSuccess implements Action {
    readonly type = BookingActionTypes.StaffAvailabilityLoadSuccess;
    constructor(public payload: StaffAvailability[]) {}
}

export class StaffAvailabilityLoadFail implements Action {
    readonly type = BookingActionTypes.StaffAvailabilityLoadFail;
    constructor(public payload: any) {}
}

export class CreateAppointment implements Action {
    readonly type = BookingActionTypes.CreateAppointment;
    constructor(public payload: CreateAppointmentRequest) {}
}

export class CreateAppointmentSuccess implements Action {
    readonly type = BookingActionTypes.CreateAppointmentSuccess;
    constructor(public payload: boolean) {}
}

export class CreateAppointmentFail implements Action {
    readonly type = BookingActionTypes.CreateAppointmentFail;
    constructor(public payload: any) {}
}

export class ClearAppointment implements Action {
    readonly type = BookingActionTypes.ClearAppointment;
    constructor() {}
}

export class ServiceCustomQuestionsLoad implements Action {
    readonly type = BookingActionTypes.ServiceCustomQuestionsLoad;
    constructor(public payload: BookingServiceRequest) {}
}

export class ServiceCustomQuestionsLoadSuccess implements Action {
    readonly type = BookingActionTypes.ServiceCustomQuestionsLoadSuccess;
    constructor(public payload: CustomQuestion[]) {}
}

export class ServiceCustomQuestionsLoadFail implements Action {
    readonly type = BookingActionTypes.ServiceCustomQuestionsLoadFail;
    constructor(public payload: any) {}
}

export type BookingActions = 
    BookingServicesLoad |
    BookingServicesLoadSuccess |
    BookingServicesLoadFail |
    SelectService |
    SchedulingPolicyLoad |
    SchedulingPolicyLoadSuccess |
    SchedulingPolicyLoadFail |
    StaffsLoad |
    StaffsLoadSuccess |
    StaffsLoadFail |
    StaffAvailabilityLoad |
    StaffAvailabilityLoadSuccess |
    StaffAvailabilityLoadFail |
    CreateAppointment |
    CreateAppointmentSuccess |
    CreateAppointmentFail |
    ClearAppointment |
    ServiceCustomQuestionsLoad |
    ServiceCustomQuestionsLoadSuccess |
    ServiceCustomQuestionsLoadFail;